"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Card } from "@/components/ui/card";
import { Loader, ChevronDown, Leaf, Sparkles, Send } from "lucide-react";
import { cn } from "@/lib/utils";
export default function BokaDinTid() {
  return <section data-section-id="118715" id="låt-oss-prata-framtid" className="relative w-full overflow-hidden bg-[#11263C] py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-24 top-10 opacity-5 mix-blend-overlay">
          <Leaf className="h-96 w-96 -rotate-45 text-white" strokeWidth={0.5} />
        </div>
        <div className="absolute -right-24 bottom-10 opacity-5 mix-blend-overlay">
          <Leaf className="h-96 w-96 rotate-12 text-white" strokeWidth={0.5} />
        </div>
        <div className="absolute left-1/2 top-1/4 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#D64045]/10 blur-[120px]" />
      </div>

      <div className="container relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="mb-4 flex justify-center">
            <Sparkles className="h-8 w-8 text-[#D64045]/60" strokeWidth={1} />
          </div>
          <h2 className="font-sans text-4xl font-bold tracking-tight text-white sm:text-5xl">
            Låt oss prata framtid
          </h2>
          <p className="mt-4 text-lg text-slate-300">
            Ring oss på 010-123 45 67, maila info@logikekonomi.se eller fyll i formuläret nedan så kontaktar vi dig inom kort.
          </p>
        </div>

        <FormProvider formKey="future_chat_form_home" formId="future_chat_form_home" sectionName="låt-oss-prata-framtid" defaultValues={{
        name: "",
        email: "",
        phone: "",
        service: "",
        date: "",
        time: "",
        message: ""
      }} validationRules={{
        name: {
          required: true,
          minLength: 2
        },
        email: {
          required: true,
          pattern: "email"
        },
        phone: {
          required: true,
          minLength: 6
        },
        service: {
          required: true
        },
        date: {
          required: true
        },
        time: {
          required: true
        }
      }} submitText="Skicka meddelande" successMessage="Tack för ditt meddelande! Vi har tagit emot din förfrågan och återkommer till dig så snart vi kan för att diskutera ditt nästa steg.">
          <BookingForm />
        </FormProvider>
      </div>
    </section>;
}
function BookingForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const serviceOptions = ["Redovisning", "Lön", "HR", "Rådgivning", "Affärssystem", "Rekrytering och Interim", "Annat"];
  const timeOptions = ["Förmiddag", "Eftermiddag", "Hela dagen"];
  if (isSubmitted && !submitError) {
    return <Card className="border-none bg-white p-12 text-center shadow-2xl">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[#D64045]/10">
          <Send className="h-8 w-8 text-[#D64045]" strokeWidth={1.5} />
        </div>
        <h3 className="mb-4 font-sans text-2xl font-bold text-[#11263C]">
          Meddelande skickat
        </h3>
        <p className="mb-8 text-slate-600">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="border-[#D64045]/20 text-[#D64045] hover:bg-[#D64045]/5">
          Skicka ett nytt meddelande
        </Button>
      </Card>;
  }
  return <Card className="border-none bg-white p-6 shadow-2xl sm:p-10">
      <Form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {}
          <FormField control={control} name="name" rules={{
          required: "Ditt namn är obligatoriskt"
        }} render={({
          field
        }) => <FormItem className="relative space-y-0">
                <FormControl>
                  <Input {...field} placeholder=" " className="peer h-14 border-slate-200 bg-slate-50 pt-6 pb-2 text-[#11263C] transition-all focus-visible:border-[#D64045]/50 focus-visible:ring-[#D64045]/20" />
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500 transition-all duration-200 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-2 peer-focus:text-xs peer-focus:text-[#D64045]">
                  Ditt namn
                </FormLabel>
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="email" rules={{
          required: "E-postadress är obligatorisk",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Ogiltig e-postadress"
          }
        }} render={({
          field
        }) => <FormItem className="relative space-y-0">
                <FormControl>
                  <Input {...field} type="email" placeholder=" " className="peer h-14 border-slate-200 bg-slate-50 pt-6 pb-2 text-[#11263C] transition-all focus-visible:border-[#D64045]/50 focus-visible:ring-[#D64045]/20" />
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500 transition-all duration-200 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-2 peer-focus:text-xs peer-focus:text-[#D64045]">
                  E-postadress
                </FormLabel>
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="phone" rules={{
          required: "Telefonnummer är obligatoriskt"
        }} render={({
          field
        }) => <FormItem className="relative space-y-0 md:col-span-2">
                <FormControl>
                  <Input {...field} type="tel" placeholder=" " className="peer h-14 border-slate-200 bg-slate-50 pt-6 pb-2 text-[#11263C] transition-all focus-visible:border-[#D64045]/50 focus-visible:ring-[#D64045]/20" />
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500 transition-all duration-200 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-2 peer-focus:text-xs peer-focus:text-[#D64045]">
                  Telefonnummer
                </FormLabel>
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="service" rules={{
          required: "Välj typ av tjänst"
        }} render={({
          field
        }) => <FormItem className="relative space-y-0 md:col-span-2">
                <FormControl>
                  <select {...field} className={cn("peer flex h-14 w-full appearance-none rounded-md border border-slate-200 bg-slate-50 px-3 pb-2 pt-6 text-sm text-[#11263C] shadow-none transition-all focus-visible:border-[#D64045]/50 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[#D64045]/20 disabled:cursor-not-allowed disabled:opacity-50", !field.value && "text-transparent")}>
                    <option value="" disabled hidden></option>
                    {serviceOptions.map((option, i) => <option key={option} value={option} data-index={i} className="text-[#11263C]">
                        {option}
                      </option>)}
                  </select>
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500">
                  Vilken tjänst är du intresserad av?
                </FormLabel>
                <ChevronDown className="pointer-events-none absolute right-3 top-5 h-4 w-4 text-slate-400 opacity-50" />
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="date" rules={{
          required: "Välj önskat datum"
        }} render={({
          field
        }) => <FormItem className="relative space-y-0">
                <FormControl>
                  <Input {...field} type="date" className="peer h-14 border-slate-200 bg-slate-50 pt-6 pb-2 text-[#11263C] transition-all focus-visible:border-[#D64045]/50 focus-visible:ring-[#D64045]/20" />
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500">
                  Föreslaget datum för genomgång
                </FormLabel>
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="time" rules={{
          required: "Välj önskad tid"
        }} render={({
          field
        }) => <FormItem className="relative space-y-0">
                <FormControl>
                  <select {...field} className={cn("peer flex h-14 w-full appearance-none rounded-md border border-slate-200 bg-slate-50 px-3 pb-2 pt-6 text-sm text-[#11263C] shadow-none transition-all focus-visible:border-[#D64045]/50 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[#D64045]/20 disabled:cursor-not-allowed disabled:opacity-50", !field.value && "text-transparent")}>
                    <option value="" disabled hidden></option>
                    {timeOptions.map((option, i) => <option key={option} value={option} data-index={i} className="text-[#11263C]">
                        {option}
                      </option>)}
                  </select>
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500">
                  Föreslagen tidpunkt
                </FormLabel>
                <ChevronDown className="pointer-events-none absolute right-3 top-5 h-4 w-4 text-slate-400 opacity-50" />
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />

          {}
          <FormField control={control} name="message" render={({
          field
        }) => <FormItem className="relative space-y-0 md:col-span-2">
                <FormControl>
                  <textarea {...field} placeholder=" " className="peer flex min-h-[120px] w-full resize-y rounded-md border border-slate-200 bg-slate-50 px-3 pb-2 pt-6 text-sm text-[#11263C] shadow-none transition-all focus-visible:border-[#D64045]/50 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[#D64045]/20 disabled:cursor-not-allowed disabled:opacity-50" />
                </FormControl>
                <FormLabel className="pointer-events-none absolute left-3 top-2 text-xs text-slate-500 transition-all duration-200 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-focus:top-2 peer-focus:text-xs peer-focus:text-[#D64045]">
                  Berätta lite om din verksamhet (frivilligt)
                </FormLabel>
                <FormMessage className="pt-1 text-xs" />
              </FormItem>} />
        </div>

        {submitError && <div className="rounded-md border border-destructive/20 bg-destructive/10 p-4 text-sm text-destructive">
            {submitError}
          </div>}

        <Button type="submit" disabled={isSubmitting} size="lg" className="group w-full bg-[#D64045] text-white transition-all duration-300 hover:bg-[#c1393d] hover:shadow-[0_0_20px_rgba(214,64,69,0.3)]">
          {isSubmitting ? <>
              <Loader className="mr-2 h-5 w-5 animate-spin" />
              Skickar...
            </> : <>
              Skicka meddelande
              <Send className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            </>}
        </Button>
      </Form>
    </Card>;
}